import { getDifferenceInSeconds, getTimestampType, } from '@office-start/date-utility';
import { format } from '@office-start/string-formatter-utility';
import { useCallback } from 'react';
import { getFormatTimeFromDate, getLocalizedDateStringLong, getLocalizedDateStringMedium, getLocalizedMonthDate, getLocalizedWeekday, } from '../getLocDateStrings';
import { getLocNumberString } from '../getLocNumberString';
import { toLocaleStringSupportsLocales } from '../toLocaleStringSupportsLocales';
// TODO: Change this hook into a utility function
export function useTransformDateTimeString(locResources, officeMarket) {
    var timespanString = useCallback(function (timespan, locString, periodInSeconds) {
        var displayNumber = Math.round(timespan / periodInSeconds);
        return format(locString, getLocNumberString(displayNumber, officeMarket));
    }, [officeMarket]);
    var commonFormat = useCallback(function (dateFrom, shortDate, fallbackText, inline, useAbsoluteDate) {
        var _a, _b, _c;
        if (!toLocaleStringSupportsLocales) {
            return fallbackText;
        }
        var timespan = getDifferenceInSeconds(dateFrom);
        if (!useAbsoluteDate) {
            switch (getTimestampType(dateFrom)) {
                case 9 /* TimestampType.InMinutes */:
                    return timespanString(timespan, locResources.numberMinutesInShort, -60);
                case 10 /* TimestampType.InHours */:
                    return timespanString(timespan, locResources.numberHoursInShort, -3600);
                case 0 /* TimestampType.None */:
                    return '';
                case 1 /* TimestampType.JustNow */:
                    return inline
                        ? locResources.justNowLowerCase
                        : locResources.justNow;
                case 2 /* TimestampType.LessThanOneHour */:
                    return timespanString(timespan, locResources.numberMinutesAgoShort, 60);
                case 3 /* TimestampType.Today */:
                    return timespanString(timespan, locResources.numberHoursAgoShort, 3600);
                case 4 /* TimestampType.Yesterday */:
                    if (shortDate) {
                        return inline
                            ? locResources.yesterdayLowerCase
                            : locResources.yesterday;
                    }
                    var formatString = inline
                        ? locResources.timeYesterdayLowerCase
                        : locResources.timeYesterday;
                    return format(formatString, (_a = getFormatTimeFromDate(dateFrom, officeMarket)) !== null && _a !== void 0 ? _a : '');
                case 5 /* TimestampType.ThisWeek */:
                    if (shortDate) {
                        return getLocalizedWeekday(dateFrom, officeMarket);
                    }
                    else {
                        return format(locResources.timeDayOfWeek, (_b = getLocalizedWeekday(dateFrom, officeMarket)) !== null && _b !== void 0 ? _b : '', (_c = getFormatTimeFromDate(dateFrom, officeMarket)) !== null && _c !== void 0 ? _c : '');
                    }
                case 6 /* TimestampType.ThisYear */:
                    return getLocalizedMonthDate(dateFrom, officeMarket);
                default:
                    return getLocalizedDateStringMedium(dateFrom, officeMarket);
            }
        }
        else {
            //Use absolute date with long format
            // Ex: Friday, September 3, 2010 12:05 PM
            return (getLocalizedDateStringLong(dateFrom, officeMarket) +
                ' ' +
                getFormatTimeFromDate(dateFrom, officeMarket));
        }
    }, [
        locResources.justNow,
        locResources.justNowLowerCase,
        locResources.numberHoursAgoShort,
        locResources.numberMinutesAgoShort,
        locResources.numberMinutesInShort,
        locResources.timeDayOfWeek,
        locResources.timeYesterday,
        locResources.timeYesterdayLowerCase,
        locResources.yesterday,
        locResources.yesterdayLowerCase,
        officeMarket,
        timespanString,
    ]);
    var transformToDateTimeString = useCallback(function (dateFrom, shortDate, fallbackText, inline, useAbsoluteDate) {
        if (!dateFrom) {
            return '';
        }
        if (fallbackText === null || typeof fallbackText === 'undefined') {
            fallbackText = dateFrom.toDateString();
        }
        return commonFormat(dateFrom, shortDate, fallbackText, inline !== null && inline !== void 0 ? inline : false, useAbsoluteDate !== null && useAbsoluteDate !== void 0 ? useAbsoluteDate : false);
    }, [commonFormat]);
    return transformToDateTimeString;
}
//# sourceMappingURL=useTransformDateTimeString.js.map